import './App.css';
import ImprovedEnterpriseLayoutPreview from './Layout/main_layout';
import LoginInterface from './login-interface';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { GlobalErrorHandler } from './components/common/GlobalErrorHandler';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import KitchenDisplayScreen from './components/modules/dineops-module/kitchen/KitchenDisplayScreen';

function App() {
  return (
    <AuthProvider>
      <GlobalErrorHandler>
        <ErrorBoundary
          showNotification={true}
          logError={true}
          errorMessage="The application encountered an error. Please try again."
        >
          <Routes>
            <Route path="/" element={<LoginInterface />} />
            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <ImprovedEnterpriseLayoutPreview />
                </ProtectedRoute>
              }
            />
            {/* The layout's old address; bookmarks and open tabs land on /home. */}
            <Route path="/Layout/main_layout" element={<Navigate to="/home" replace />} />
            {/* DineOps kitchen display: a wall screen, served without the shell
                (plan §5.2). Same CRS login; the route is guarded like the layout. */}
            <Route
              path="/kitchen-display"
              element={
                <ProtectedRoute>
                  <KitchenDisplayScreen />
                </ProtectedRoute>
              }
            />
            {/* other routes */}
          </Routes>
        </ErrorBoundary>
      </GlobalErrorHandler>
    </AuthProvider>
  );
}

export default App;
